// extracted by mini-css-extract-plugin
export default {"container":"JNxVBA","dot":"mnxIuN","opacitychange":"xDDB8S"};